import { LabradorComponent, StandaloneComponent } from '@/types/component';
import { standaloneComponent } from 'modules/dynamic-components';
import { StandaloneLinkProps } from '../Link';

const Link = standaloneComponent<StandaloneLinkProps>('ElementLink');

export type StandaloneOptionalLinkProps = StandaloneLinkProps;

const StandaloneOptionalLink: StandaloneComponent<StandaloneOptionalLinkProps> = ({ content, href, ...props }) => {
  return href ? <Link {...{ content, href }} {...props} /> : content;
};

export const standalone = StandaloneOptionalLink;

const LabradorOptionalLink: LabradorComponent = () => <StandaloneOptionalLink />;

export default LabradorOptionalLink;
